<template>
  <div>
    <section class="banner">
      <div class="container">
        <article class="row align-items-center">
          <aside class="col-md-7">
            <!-- <h2>DECENTRALIZED CRYPTOCURRENCY <br>IS PRODUCED.</h2> -->
            <h2>Easily switch between stable coins with a fixed fee of $1</h2>
            <p>
              Welcome to Stable Switch. We are dedicated to providing you with
              the tools you need to Switch between stable coins without having
              to worry about things like slippage or sub $1 Switch prices.
            </p>
            <a
              href="#"
              class="btn_default"
              data-toggle="modal"
              data-target="#exampleModal3"
              >Read More</a
            >
          </aside>
          <aside class="col-md-5">
            <div class="banner_right_box">
              <h4>Choose Which Assets to Switch</h4>
              <div class="quantity">
                <div class="form-group">
                  <label for="quantity">Quantity</label>
                  <input
                    id="quantity"
                    type="number"
                    class="form-control"
                    v-model="swapAmount"
                    @input="setSwapAmount"
                    @change="setSwapAmount"
                  />
                </div>
              </div>
              <div class="cc-selector">
                <h5>Deposit</h5>
                <span v-for="(item, index) in tokenList" :key="item.name">
                  <input
                    :id="'selector' + (index + 1)"
                    type="radio"
                    name="currancy"
                    :value="'selector' + (index + 1)"
                    :checked="depositSelection == index"
                  />
                  <label
                    :class="'drinkcard-cc ' + 'icon' + (index + 1)"
                    :for="'selector' + (index + 1)"
                    @click="flipTokenInTokenOut('deposit', index)"
                  ></label>
                </span>
                <!-- <input id="selector3" type="radio" name="currancy" value="selector3"/>
                                <label class="drinkcard-cc icon3" for="selector3"></label>
                                <input id="selector4" type="radio" name="currancy" value="selector4"/>
                                <label class="drinkcard-cc icon4" for="selector4"></label> -->
              </div>
              <div class="cc-selector">
                <h5>Receive</h5>
                <span v-for="(item, index) in tokenList" :key="item.name">
                  <input
                    :id="'receive' + (index + 1)"
                    type="radio"
                    name="currancy2"
                    :value="'receive' + (index + 1)"
                    :checked="receiveSelection == index"
                  />
                  <label
                    :class="'drinkcard-cc ' + 'icon' + (index + 1)"
                    :for="'receive' + (index + 1)"
                    @click="flipTokenInTokenOut('receive', index)"
                  ></label>
                </span>
                <!-- <input id="selector7" type="radio" name="currancy2" value="selector7"/>
                                <label class="drinkcard-cc icon3" for="selector7"></label>
                                <input id="selector8" type="radio" name="currancy2" value="selector8"/>
                                <label class="drinkcard-cc icon4" for="selector8"></label> -->
              </div>
              <div class="exchange_button">
                <b-button
                  size="lg"
                  class="btn_blue"
                  :disabled="isSwapBtnDisabled"
                  @click="switchSave()"
                >
                  Switch Now
                </b-button>
              </div>
            </div>
          </aside>
        </article>
      </div>
    </section>

    <!-- <section class="about">
          <div class="container">
            <article class="row align-items-center">
              <aside class="col-md-6">
                <div class="about_right">
                  <img src="../assets/images/about.png" alt="">
                </div>
              </aside>
              <aside class="col-md-6">
                <div class="about_left">
                </div>
              </aside>
            </article>
          </div>
        </section> -->

    <section class="exchange_effect">
      <div class="container">
        <h3>Liquidity Pool</h3>
        <p>Click on each row to expand the analysis</p>
        <div class="exchange_effect_table">
          <div class="table-responsive">
            <table>
              <thead>
                <tr>
                  <th width="33.3333%">Liquidity pool</th>
                  <th width="33.3333%">value</th>
                  <th width="33.3333%">Fee Generated(last 24 hours)</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <img src="../assets/images/USDC.png" alt="" />USDC
                    <span
                      ><img src="../assets/images/right-arrow.png" alt=""
                    /></span>
                    <img src="../assets/images/USDT.png" alt="" />USDT
                  </td>
                  <td>{{tokenList && tokenList.length > 0 ? (tokenList[0].balance) : 0}}</td>
                  <td>{{ feesPrice | formatNum }}</td>
                </tr>
                <tr>
                  <td>
                    <img src="../assets/images/USDT.png" alt="" />USDT
                    <span
                      ><img src="../assets/images/right-arrow.png" alt=""
                    /></span>
                    <img src="../assets/images/USDC.png" alt="" />USDC
                  </td>
                  <td>{{tokenList && tokenList.length > 0 ? (tokenList[1].balance) : 0}}</td>
                  <td>{{ feesPrice | formatNum }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>

    <section class="how_it_works">
      <div class="container">
        <article class="row align-items-center">
          <aside class="col-md-5">
            <div class="how_it_works_left">
              <img src="../assets/images/how-it-work-new.png" alt="" />
            </div>
          </aside>
          <aside class="col-md-7">
            <div class="how_it_works_right">
              <h2>How It Works</h2>
              <p>
                So, how does the Stable Switch work? What do you need to know to get the
                most from your experiences?
              </p>
              <p>
                The website has been built to allow people to Switch
                cryptocurrency, as you’re no doubt aware. We specialise in
                Stablecoin cryptocurrency. Every coin that we switch will have
                a value of exactly $1. There’s no fluctuations on that - a
                radical departure from the conventional practices of slippage
                and volatile pricing. In the past, it used to be the case that a
                stablecoin was worth more than $1, but also less than $1 on
                occasion. It made it difficult to switch with any real
                efficiency, which is why we decided to change things.
              </p>
              <router-link to="how-it-works" class="btn_blue"
                >Read More</router-link
              >
            </div>
          </aside>
        </article>

        <!-- <article class="row">
                  <aside class="col-md-4">
                    <div class="how_it_works_inner">
                      <div class="how_it_works_img">
                        <img src="../assets/images/how-it-work1.jpg" alt="">
                      </div>
                      <div class="how_it_works_text">
                        <h4>Step 1</h4>
                        <p>Select the coins and the quantity you want to trade and click exchange now </p>
                      </div>
                    </div>
                  </aside>
                  <aside class="col-md-4">
                    <div class="how_it_works_inner">
                      <div class="how_it_works_img">
                        <img src="../assets/images/how-it-work2.jpg" alt="">
                      </div>
                      <div class="how_it_works_text">
                        <h4>Step 2</h4>
                        <p>Check the information is correct for your Stable Switch  and enter your ERC20 token address to receive your funds </p>
                      </div>
                    </div>
                  </aside>
                  <aside class="col-md-4">
                    <div class="how_it_works_inner">
                      <div class="how_it_works_img">
                        <img src="../assets/images/how-it-work3.jpg" alt="">
                      </div>
                      <div class="how_it_works_text">
                        <h4>Step 3</h4>
                        <p>You can now watch the progress of your Stable Switch and also view the transaction on Etherscan </p>
                      </div>
                    </div>
                  </aside>
                </article> -->
      </div>
    </section>

    <section class="fud_wrapp">
      <div class="container">
        <article class="row align-items-center">
          <aside class="col-md-9">
            <div class="fud_wrapp_left">
              <h4>
                Add Funds to the Stable Switch Liquidity Pool and earn a
                percentage of the shared platform fees
              </h4>
            </div>
          </aside>
          <aside class="col-md-3">
            <div class="fud_wrapp_right">
              <router-link class="btn_blue" to="liquidity"
                >Find Out More
              </router-link>
            </div>
          </aside>
        </article>
      </div>
    </section>

    <div
      class="modal fade banner_modal"
      id="exampleModal3"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <h2>Easily trade between stable coins with a fixed fee of $1</h2>
            <p>
              Welcome to Stable Switch. We are dedicated to providing you with
              the tools you need to Switch between stable coins without having
              to worry about things like slippage or sub $1 Switch prices.
            </p>
            <p>
              The most amazing thing about the Stable Switch dynamic fee system
              is if the free turns negative.. We will effectively will paying
              you to trade on the platform. Alongside the benefits of trading
              with us.
            </p>
            <p>
              If you’re interested in this particular part of trading, then feel
              free to visit the fee section of the homepage - it gives you
              access to the best Switch rates on the site. So, as you can tell,
              we’re pretty excited to start providing you with the services that
              you need - why not look around and see what’s on offer? There’s
              plenty to check out, a lot of different services to explore, and
              plenty of benefits for our users. We want you to trade with us,
              which is why everything that we do is for you. We understand
              exactly how important it can be for you to have confidence when
              your trading online - there are other websites which seem to be
              more concerned with their own profits than with yours - that’s not
              how we do things
            </p>
            <p>
              With that in mind, please feel free to have a look around the
              website to see what we can do for you. We offer a whole selection
              of different services for you to get a look at and plenty of
              support too. If you’re not sure about something or you need some
              support, a member of the customer service team would be happy to
              help you out. We’re all friendly and know a lot about the ins and
              outs of trading, so they will be more than happy to help you to
              figure out exactly what you need. Please get in touch, and we’ll
              sit down and help try to crack your problem.
            </p>
            <p>
              All of the stable coins on Stable Switch trade for exactly $1
              every time, so you don’t have to worry about issues like slippage.
              We know how frustrating it can be to suddenly have your money
              decrease in value due to market inefficiencies, so we aim to make
              sure that doesn’t happen. You can Switch stable coins as often as
              you like - with no concerns whatsoever.
            </p>
            <p>
              We are introducing an industry-first Switch fee. Our incredible
              dynamic Switch process means that you can get absolutely superb
              rates based on our liquidity pool volumes. We have fees ranging
              from 0.2 % through to 1.2%, and we actively reward depositors who
              replenish the pools with the lowest supplies thanks to these
              rates. You keep more of the benefits, and we continue to provide
              you with a reliable service - it’s pretty much a win/win for
              everyone!
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { gql } from "apollo-boost";
import { mapGetters } from "vuex";
import router from "../router/index";

export default {
  name: "Home",
  computed: {
    ...mapGetters(["contracts", "erc20TokenContract", "account","feesPrice"]),
    trades() {
      if (this.swaps && this.swaps.length > 0) {
        return _.orderBy(this.swaps, ["timestamp"], ["desc"]).map((trade) => ({
          id: trade.id,
          transaction_hash: this.$options.filters.toShortAccount(trade.id),
          sender: this.$options.filters.toShortAccount(trade.sender),
          token_in: trade.tokenInName,
          token_out: trade.tokenOutName,
          amount: `$${this.$options.filters.currency(
            this.$options.filters.toEth(trade.amount)
          )}`,
          total_fee: `$${this.$options.filters.currency(
            this.$options.filters.toEth(trade.fee)
          )}`,
          supplier_fee: `$${this.$options.filters.currency(
            this.$options.filters.toEth(trade.supplierFee)
          )}`,
          pool_fee: `$${this.$options.filters.currency(
            this.$options.filters.toEth(trade.incentivePoolFee)
          )}`,
        }));
      }

      return [];
    },
    etherscanTxLink() {
      return `https://etherscan.io/tx/${this.txHash}`;
    },
  },
  data() {
    return {
      tokenList: [],
      depositSelection: 0,
      receiveSelection: 1,
      swapAmount: "",
      isSwapBtnDisabled: true,
    };
  },
  apollo: {
    swaps: {
      query: gql(`query {
                swaps {
                    id
                    tokenInName
                    tokenOutName
                    amount
                    sender
                    timestamp
                    fee
                }
            }`),
      pollInterval: 2000,
    },
    liquidityPair: {
      query: gql(`query {
                liquidityPair(id: "${"0x60Daf89be825A35C58ACE1f17aAACDeb5b0B08D2".toLowerCase()}") {
                    pairName
                    tokenALiquidity
                    tokenARatio
                    tokenBLiquidity
                    tokenBRatio
                    totalLiquidity
                    tokenA
                    tokenAName
                    tokenASymbol
                    tokenB
                    tokenBName
                    tokenBSymbol
                    minimumDeposit
                    maximumDeposit
                }
            }`),
      pollInterval: 2000,
      result({ data }) {
        const { liquidityPair } = data;
        this.tokenList = [];
        this.tokenList.push({
          name: liquidityPair.tokenAName,
          address: liquidityPair.tokenA,
          liquidity: liquidityPair.tokenALiquidity,
          ratio: liquidityPair.tokenARatio,
          balance:this.$options.filters.formatNum(
            this.$options.filters.toEth(liquidityPair.tokenALiquidity)
          )
        });

        this.tokenList.push({
          name: liquidityPair.tokenBName,
          address: liquidityPair.tokenB,
          liquidity: liquidityPair.tokenBLiquidity,
          ratio: liquidityPair.tokenBRatio,
          balance:this.$options.filters.formatNum(
            this.$options.filters.toEth(liquidityPair.tokenBLiquidity)
          )
        });
      },
    },
  },
  methods: {
    flipTokenInTokenOut(type, value) {
      // const oldTokenIn = this.tokenIn;
      // this.tokenIn = this.tokenOut;
      // this.tokenOut = oldTokenIn;
      if (type == "deposit") {
        this.depositSelection = value;
        if (this.receiveSelection == this.depositSelection) {
          if (this.depositSelection != 0) {
            this.receiveSelection = 0;
          } else {
            this.receiveSelection = 1;
          }
        }
      } else {
        this.receiveSelection = value;
        if (this.depositSelection == this.receiveSelection) {
          if (this.receiveSelection != 0) {
            this.depositSelection = 0;
          } else {
            this.depositSelection = 1;
          }
        }
      }
    },
    switchSave() {
      this.$store.state.depositSelection = this.depositSelection;
      this.$store.state.receiveSelection = this.receiveSelection;
      this.$store.state.swapAmount = this.swapAmount;

      router.push({ path: "/exchange" });
    },
    setSwapAmount() {
      if (this.swapAmount > 0) {
        this.isSwapBtnDisabled = false;
      } else {
        this.isSwapBtnDisabled = true;
      }
    },
    async startTimer() {
      await this.$store.dispatch("loadData");
      setInterval(async () => {
        await this.$store.dispatch("loadData");
      }, 10000);
    },
  },
  async mounted() {
    this.startTimer();
  },
  beforeDestroy() {},
};
</script>
